import React from "react";
import {
  APPLE_DOWNLOAD_URL,
  GOOGLE_DOWNLOAD_URL,
  HABLO_APP_DOWNLOAD_URL,
  PRIVACY_POLICY_URL,
  USER_AGREEMENT_URL
} from "../../../../config/config";
import "./style.css";

export const PcWeb = ({ clickNext = () => {}, clickPrev = () => {}, clicked, isCurPage, }) => {
  return (
    <div className="WEB" data-model-id="343:935">
      <div className="web-pc">
        <div className="top">
          <a href={"/"}>
            <img className="vector" alt="Vector" src="/static/image/web/home/pc/img-logo.png" />
          </a>

          <a href={HABLO_APP_DOWNLOAD_URL} className="button">
            <div className="button-text-wrapper">
              <span className="button-text">Try for Free</span>
            </div>
          </a>
        </div>
        
        <div className={'videos'}>
          <video 
            className="video" 
            controls 
            preload="metadata"
            
          >
            <source src="/static/videos/justfit_main.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          
          <video 
            className="video" 
            controls 
            preload="metadata"
            
          >
            <source src="/static/videos/justfit_0409.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          
          <video 
            className="video" 
            controls 
            preload="metadata"
            
          >
            <source src="/static/videos/justfit_0415.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          
          <video 
            className="video" 
            controls 
            preload="metadata"
            
          >
            <source src="/static/videos/justfit_0421.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          
          <video 
            className="video" 
            controls 
            preload="metadata"
            
          >
            <source src="/static/videos/justfit_0428.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          
          <video 
            className="video" 
            controls 
            preload="metadata"
            
          >
            <source src="/static/videos/justfit_0508.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          
          <video 
            className="video" 
            controls 
            preload="metadata"
            
          >
            <source src="/static/videos/justfit_0512.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          
          <video 
            className="video" 
            controls 
            preload="metadata"
            
          >
            <source src="/static/videos/justfit_0519.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          
          <video 
            className="video" 
            controls 
            preload="metadata"
            
          >
            <source src="/static/videos/justfit_0526.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          
          <video 
            className="video" 
            controls 
            preload="metadata"
            
          >
            <source src="/static/videos/justfit_0603.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          
          <video 
            className="video" 
            controls 
            preload="metadata"
            
          >
            <source src="/static/videos/justfit_0610.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          
          <video 
            className="video" 
            controls 
            preload="metadata"
            
          >
            <source src="/static/videos/justfit_0617.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          
          <video 
            className="video" 
            controls 
            preload="metadata"
            
          >
            <source src="/static/videos/justfit_0623.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          
          <video 
            className="video" 
            controls 
            preload="metadata"
            
          >
            <source src="/static/videos/justfit_0702.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          
          <video 
            className="video" 
            controls 
            preload="metadata"
            
          >
            <source src="/static/videos/justfit_composite.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>

        <div className="div-shared-default">
          <a 
            href={PRIVACY_POLICY_URL} 
            className="footer-text"
          >
            Privacy Policy
          </a>

          <div className="text-wrapper">Contact us:</div>

          <a
            className="div"
            href="mailto:support@thevisionext.com"
            rel="noopener noreferrer"
            target="_blank"
          >
            support@thevisionext.com
          </a>

          <a 
            href={USER_AGREEMENT_URL} 
            className="footer-text-2"
          >
            Terms of Use
          </a>
          <a href={APPLE_DOWNLOAD_URL} target="_blank" >
          <img className="frame" alt="Frame" src="/static/image/web/video/pc/frame.png" />
          </a>
          <a href={GOOGLE_DOWNLOAD_URL} target="_blank" >
          <img className="img" alt="Frame" src="/static/image/web/video/pc/frame-1.png" />
          </a>
        </div>
      </div>
    </div>
  );
};
